import PropTypes from "prop-types"
import React, { useEffect, useState, useMemo, useCallback, useContext } from "react"
import { Input, Badge } from "reactstrap"

import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom"

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb3';
import TableContainer from '../../components/Common/TableContainer';
import { withTranslation } from "react-i18next";

import { get } from "helpers/api_helper";
import { checkScope } from "helpers/utility_helper";
import "../../components/Common/datatables.scss"
import Spinners from "components/Common/Spinner";

import ModalContext from "../../contexts/ModalContext";
import moment from "moment";
import InputSwitch from "components/Input/InputSwitch";
import fn_helper from "helpers/fn_helper";

// Service
import {
    SearchContent,
    PatchContent,
    DeleteContent,
} from "./_services/Services.js"
import Error401 from "components/Error401";

const RowStatus = fn_helper.TABLE.RowStatus;

const SitemapList = props => {
    const _pageName = `Sitemap - Menu Level ${props.menuLevel}`
    const _routeLink = `sitemap`;
    const _routePermission = `sitemap`

    // POPUP
    const { mAlert } = useContext(ModalContext);

    // OTHER STATE
    const qParams = useParams()
    const qLang = _.upperCase(qParams?.lang) ?? 'TH'
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();

    // LOCAL STATE
    const [contentList, setContentList] = useState([])
    const [contentListLoading, setContentListLoading] = useState(false)
    const [selectedContentId, setSelectedContentId] = useState([])

    let _pageSettingTable = ''
    let _pageRoute = []
    switch (props.menuLevel) {
        case "1":
            _pageSettingTable = 'sitemap_setting_cate'
            _pageRoute =
                [{ title: _pageName, link: "" },
                { title: `${_pageName}` },
                ]
            break;
        case "2":
        case "3":
            if (props.menuLevel === "2") {
                _pageRoute =
                    [{ title: 'Sitemap - Menu Level 1', link: `/${_routeLink}/level/1/${qLang}` },
                    { title: `${_pageName}` },
                    ]
            } else {
                _pageRoute =
                    [{ title: 'Sitemap - Menu Level 1', link: `/${_routeLink}/level/1/${qLang}` },
                    { title: 'Sitemap - Menu Level 2', link: `/${_routeLink}/level/2/fromMenuId/${qParams?.fromMenuId}/fromLevel/${qParams?.fromLevel}/${qLang}` },
                    { title: `${_pageName}` },
                    ]
            }
            break;
        default:
            _pageRoute = [{ title: `${_pageName}`, link: "" }]
            break;
    }

    const onDeleteRow = (ids = [], name = '') => {
        // alert('onDeleteRow'+ JSON.stringify(ids))
        mAlert.info({
            type: "confrim",
            title: "Alert Confrim",
            subTitle: `Are you sure Delete ${name} ?`,
            mode: "red",
            content: "",
            onClose: () => { },
            onYes: () => {
                const payload = { mainIds: ids };
                API.fetchDeleteContentList(payload)
            },
            onNo: () => { console.log("Cancel") },
        })
    }

    const onPatchRow = (id = 0, fieldName = '', value = null) => {
        const payload = { id: id, fieldName: fieldName, value: value };
        API.fetchPatchContent(payload)
    }

    const onSelectionChange = fn_helper.TABLE.onSelectionChange;

    const columns = useMemo(
        () => [
            {
                id: "colcheckbox",
                header: (cellProps) => {
                    const row = cellProps?.row?.original
                    return (
                        <div style={{ display: "flex", justifyContent: "center" }}>
                            <Input
                                type={`checkbox`}
                                checked={contentList && (contentList.length === 0 ? false : contentList.length === selectedContentId.length)}
                                onClick={() => {
                                    let updateData = onSelectionChange(row, selectedContentId, contentList, "all")
                                    console.log("🚀 ~ ExecutivesList ~ updateData:", updateData)
                                    setSelectedContentId(updateData)
                                }}
                                readOnly
                            />
                        </div>
                    )
                },
                enableColumnFilter: false,
                enableSorting: false,
                cell: (cellProps) => {
                    const row = cellProps?.row?.original
                    return (
                        <>
                            <div id={cellProps.row.id} style={{ display: "flex", justifyContent: "center" }}>
                                <Input
                                    type={`checkbox`}
                                    checked={selectedContentId.includes(row.contentId)}
                                    onClick={() => {
                                        let updateData = onSelectionChange(row, selectedContentId, contentList)
                                        setSelectedContentId(updateData)
                                    }}
                                    readOnly
                                />
                            </div>
                        </>
                    )
                }
            },
            {
                header: '#No.',
                accessorKey: 'sequence',
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    const row = cellProps?.row?.original
                    return (
                        <>
                            <div style={{ display: "flex", justifyContent: "left" }}>
                                {(cellProps.row.index + 1)}
                            </div>
                        </>
                    )
                }
            },
            {
                header: 'Menu Name',
                accessorKey: 'contentPageName',
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: 'Written at',
                accessorKey: 'postDate',
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    const row = cellProps?.row?.original
                    return row.postDate ? moment(row.postDate).format('DD/MM/YYYY HH:mm:ss') : ''
                }
            },
            {
                header: 'Status',
                accessorKey: 'contentStatus',
                enableColumnFilter: false,
                enableSorting: true,
                width: '10%',
                cell: (cellProps) => {
                    const { id, contentStatus } = cellProps.row.original

                    return <RowStatus status={contentStatus} />
                    // return (
                    //     <InputSwitch
                    //         labelON=""
                    //         labelOFF=""
                    //         value={status == 1}
                    //         onChange={(value)=> {
                    //             const updateValue = value ? 1 : 0
                    //             onPatchRow(id, 'status', updateValue)
                    //         }}
                    //     />
                    // )
                }
            },
            {
                header: 'Tools',
                accessorKey: 'main_id',
                enableColumnFilter: false,
                enableSorting: false,
                cell: (cellProps) => {
                    let { mainId, platformName } = cellProps?.row?.original ?? {};
                    const id = mainId
                    if ([2, 3].includes(Number(props.menuLevel))) {
                        return (
                            <>
                                {props.menuLevel == 2 && checkScope(`${_routePermission}:view`) && <a className={`btn btn-info`} href={`/${_routeLink}/level/${Number(props.menuLevel) + 1}/fromMenuId/${id}/fromLevel/${Number(props.menuLevel)}/${qLang}`}><i className={`bx bx-show-alt`}></i> Sub Menu</a>}
                                &nbsp;
                                {checkScope(`${_routePermission}:view`) && <Link className={`btn btn-info`} to={`/${_routeLink}/level/${Number(props.menuLevel)}/fromMenuId/${qParams.fromMenuId}/fromLevel/${Number(props.menuLevel)}/${qLang}/view/${id}`}><i className={`bx bx-show-alt`}></i></Link>}
                                &nbsp;
                                {checkScope(`${_routePermission}:update`) && <Link className={`btn btn-warning`} to={`/${_routeLink}/level/${Number(props.menuLevel)}/fromMenuId/${qParams.fromMenuId}/fromLevel/${Number(props.menuLevel)}/${qLang}/edit/${id}`}><i className={`bx bx-edit-alt`}></i></Link>}
                                &nbsp;
                                {checkScope(`${_routePermission}:delete`) && <a className={`btn btn-danger`} onClick={() => onDeleteRow([id], platformName)}><i className={`bx bx-trash`}></i></a>}
                            </>
                        )
                    }
                    else {
                        return (
                            <>
                                {checkScope(`${_routePermission}:view`) && <a className={`btn btn-info`} href={`/${_routeLink}/level/${Number(props.menuLevel) + 1}/fromMenuId/${id}/fromLevel/${Number(props.menuLevel)}/${qLang}`}><i className={`bx bx-show-alt`}></i> Sub Menu</a>}
                                &nbsp;
                                {checkScope(`${_routePermission}:view`) && <Link className={`btn btn-info`} to={`/${_routeLink}/level/${Number(props.menuLevel)}/${qLang}/view/${id}`}><i className={`bx bx-show-alt`}></i></Link>}
                                &nbsp;
                                {checkScope(`${_routePermission}:update`) && <Link className={`btn btn-warning`} to={`/${_routeLink}/level/${Number(props.menuLevel)}/${qLang}/edit/${id}`}><i className={`bx bx-edit-alt`}></i></Link>}
                                &nbsp;
                                {checkScope(`${_routePermission}:delete`) && <a className={`btn btn-danger`} onClick={() => onDeleteRow([id], platformName)}><i className={`bx bx-trash`}></i></a>}
                            </>
                        )
                    }
                }
            },
        ],
        [selectedContentId, contentList]
    );

    const API = {
        fetchContentList: async () => {
            try {
                const response = await SearchContent(props.menuLevel, qParams?.fromMenuId ?? 1, { lang: qLang })
                const resData = response?.data ?? []
                setContentList(resData.data);
            } catch (e) {
                console.log(e)
                mAlert.info({
                    title: "Alert",
                    subTitle: "Something went wrong",
                    content: "",
                    onClose: () => {
                        //  alert("onClose")
                    },
                })
            } finally {
                setContentListLoading(false)
            }
        },
        fetchPatchContent: async (payload) => {
            try {
                const response = await PatchContent(props.menuLevel, qParams?.fromMenuId ?? 1, { data: payload, id: payload.id, lang: qLang })
                const resData = response.data
                if (resData.status === 202) {
                    mAlert.info({
                        title: "Alert",
                        subTitle: "Update Data Success",
                        content: "",
                        onClose: () => {
                            fetchAPI()
                        },
                    })
                }
            }
            catch (err) {
                console.log('err ', err)
                mAlert.info({
                    title: "Alert",
                    subTitle: "Something went wrong",
                    content: "",
                    onClose: () => {
                        //  alert("onClose")
                    },
                })
            }
        },
        fetchDeleteContentList: async (payload) => {
            try {
                const response = await DeleteContent(props.menuLevel, qParams?.fromMenuId ?? 1, { data: payload, lang: qLang })
                const resData = response.data
                if (resData.status === 202) {
                    mAlert.info({
                        title: "Alert",
                        subTitle: "Delete Data Success",
                        content: "",
                        onClose: () => {
                            fetchAPI()
                        },
                    })
                }
            }
            catch (err) {
                console.log('err ', err)
                mAlert.info({
                    title: "Alert",
                    subTitle: "Something went wrong",
                    content: "",
                    onClose: () => {
                        //  alert("onClose")
                    },
                })
            }
        }

    }

    const fetchAPI = () => {
        const payload = {}
        API.fetchContentList(payload)
    }

    useEffect(() => {
        setContentListLoading(true)
        fetchAPI()
    }, [qLang]);

    // useEffect(() => {
    //     if (contentList.length) {
    //         setContentListLoading(false)
    //     }
    // }, [contentList])

    //meta title
    document.title = `${_pageName} | ` + process.env.REACT_APP_CMS_TITLE;

    if (!checkScope(`${_routePermission}:list`)) {
        return <Error401 />
    }


    return (
        <div className="page-content">
            <div className="container-fluid">
                <Breadcrumbs title={`${_pageName}`} breadcrumbItems={_pageRoute} />
                {
                    <TableContainer
                        isAddButton={true}
                        addRowLink={`/create`}
                        columns={columns}
                        data={contentList || []}
                        isGlobalFilter={true}
                        isPagination={true}
                        SearchPlaceholder="Search"
                        pagination="pagination"
                        paginationWrapper='dataTables_paginate paging_simple_numbers'
                        tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                        theadClass="table-light"
                        rootMenu="systemsettings"
                        subMenu="usersetting"
                        isCustomPageSize={true}
                        isSelected={selectedContentId.length > 0}
                        onClearSelected={() => setSelectedContentId([])}
                        onDeleleSelected={() => onDeleteRow(_.cloneDeep(selectedContentId))}
                        isExportButton={true}
                        routePermission={_routePermission}
                        //loading={contentListLoading}
                        sortTable={{
                            tableName: _pageSettingTable,
                            fetchCallBack: () => {
                                setContentListLoading(true)
                                fetchAPI()
                            }
                        }}
                    // backButton={[2, 3].includes(Number(props.menuLevel))}
                    // backButtonLabel={`Back to Level ${Number(props.menuLevel) - 1}`}
                    // backButtonLink={`/sitemap/level/${Number(props.menuLevel)}/fromMenuId/${qParams.fromMenuId}/fromLevel/${Number(qParams.fromLevel)}/${qLang}`}
                    // menuLevel={props.menuLevel}
                    />
                }
            </div>
        </div>
    );
}

SitemapList.propTypes = {
    t: PropTypes.any,
}

export default withTranslation()(SitemapList)
